import { render, staticRenderFns } from "./ProgramSelectbox.vue?vue&type=template&id=22faf1bd"
import script from "./ProgramSelectbox.vue?vue&type=script&lang=js"
export * from "./ProgramSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports